import {
  ItemListContainer,
  ItemWrapper,
  ItemInfoWrapper,
  ItemTitleWrapper,
  ColumnWrapper,
  ItemLeftWrapper,
  ItemActionsWrapper,
  ContentColapsibleWrapper,
  RepairsOrdersSectionContainer,
  RepairsOrdersSectionRow,
} from "./RepairsOrdersItemList.styled";
import { Typography, Button, Tag, Icon } from "@ann/web-components";
import { useState } from "react";

const RepairsOrdersItem = ({ info }) => {
  const [showInfo, setShowInfo] = useState(false);
  return (
    <ItemListContainer>
      <ItemWrapper>
        <ItemLeftWrapper>
          <ItemTitleWrapper>
            <Icon name="build" size="medium" color="primary" />
            <Typography category="subtitle" weight="bold" size="medium" color="subtitle">
              {info.vehicle}
            </Typography>
          </ItemTitleWrapper>
          <ItemInfoWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                RO Number
              </Typography>
              <Typography category="body" weight="regular" size="small" color="body" maxCharacters={15}>
                {info.roNumber}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Mileage In
              </Typography>
              <Typography category="body" weight="regular" size="small" color="body" maxCharacters={15}>
                {info.mileageIn}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Status
              </Typography>
              <Tag text={info.statusDescription} color={info.statusColor} size="medium" />
            </ColumnWrapper>
          </ItemInfoWrapper>
        </ItemLeftWrapper>
        <ItemActionsWrapper>
          <Button
            size="small"
            type="secondary"
            icon={showInfo ? "chevronUp" : "chevronDown"}
            pill={true}
            onClick={() => setShowInfo(!showInfo)}
          />
        </ItemActionsWrapper>
      </ItemWrapper>
      {showInfo && (
        <ContentColapsibleWrapper>
          <RepairsOrdersSectionContainer>
            <RepairsOrdersSectionRow>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Appointment
              </Typography>
              <Typography category="body" weight="regular" size="small" color="body">
                {info.appointment}
              </Typography>
            </RepairsOrdersSectionRow>
          </RepairsOrdersSectionContainer>
          <RepairsOrdersSectionContainer>
            <RepairsOrdersSectionRow>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Cost Breakdown
              </Typography>
              <Typography category="body" weight="regular" size="small" color="body">
                {[
                  info.customerPay ? `Customer: ${info.customerPay}` : null,
                  info.warrantyPay ? `Warranty: ${info.warrantyPay}` : null,
                ]
                  .filter(Boolean)
                  .join(" · ") || "—"}
              </Typography>
            </RepairsOrdersSectionRow>
            <RepairsOrdersSectionRow>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Opened
              </Typography>
              <Typography category="body" weight="regular" size="small" color="body">
                {info.opened || "—"}
              </Typography>
            </RepairsOrdersSectionRow>
            <RepairsOrdersSectionRow>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Closed
              </Typography>
              <Typography category="body" weight="regular" size="small" color="body">
                {info.closed || "—"}
              </Typography>
            </RepairsOrdersSectionRow>
          </RepairsOrdersSectionContainer>
          <RepairsOrdersSectionContainer>
            <RepairsOrdersSectionRow>
              <Typography category="caption" weight="regular" size="medium" color="subtitle">
                CUSTOMER PAY
              </Typography>
              <Typography category="body" weight="regular" size="small" color="body">
                {info.customerPay || "—"}
              </Typography>
            </RepairsOrdersSectionRow>
            <RepairsOrdersSectionRow>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Warranty Pay
              </Typography>
              <Typography category="body" weight="regular" size="small" color="body">
                {info.warrantyPay || "—"}
              </Typography>
            </RepairsOrdersSectionRow>
            <RepairsOrdersSectionRow>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Total RO
              </Typography>
              <Typography category="body" weight="regular" size="small" color="body">
                {info.totalRO || "—"}
              </Typography>
            </RepairsOrdersSectionRow>
          </RepairsOrdersSectionContainer>
          <RepairsOrdersSectionContainer>
            <RepairsOrdersSectionRow>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Service Advisor
              </Typography>
              <Typography category="body" weight="regular" size="small" color="body">
                {info.serviceAdvisor || "—"}
              </Typography>
            </RepairsOrdersSectionRow>
            <RepairsOrdersSectionRow>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Last Service
              </Typography>
              <Typography category="body" weight="regular" size="small" color="body">
                {info.lastService || "—"}
              </Typography>
            </RepairsOrdersSectionRow>
            <RepairsOrdersSectionRow>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                VIN
              </Typography>
              <Typography category="body" weight="regular" size="small" color="body">
                {info.vin || "—"}
              </Typography>
            </RepairsOrdersSectionRow>
          </RepairsOrdersSectionContainer>
        </ContentColapsibleWrapper>
      )}
    </ItemListContainer>
  );
};

export default RepairsOrdersItem;